import React, { useState, useEffect, useCallback } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, HStack, Input, FormControl, FormLabel,
  Box, Text, useToast, Flex, IconButton,
} from '@chakra-ui/react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import api from '../api';

export default function SocialNetworksModal({ isOpen, onClose }) {
  const [networks, setNetworks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', base_url: '' });
  const toast = useToast();

  const fetch = useCallback(async () => {
    try { const { data } = await api.get('/social/networks'); setNetworks(data); } catch(e) {}
  }, []);

  useEffect(() => { if (isOpen) { fetch(); setShowForm(false); } }, [isOpen, fetch]);

  const handleAdd = async () => {
    if (!form.name) return;
    try {
      await api.post('/social/networks', form);
      setForm({ name: '', base_url: '' }); setShowForm(false); await fetch();
      toast({ title: 'Added', status: 'success', duration: 1500 });
    } catch(e) { toast({ title: e.response?.data?.error || 'Failed', status: 'error', duration: 2000 }); }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" scrollBehavior="inside">
      <ModalOverlay /><ModalContent>
        <ModalHeader fontSize="md">
          <Flex justify="space-between" pr={8}>Social Networks
            <Button size="xs" leftIcon={<FiPlus />} colorScheme="blue" variant="outline"
              onClick={() => setShowForm(!showForm)}>{showForm ? 'Cancel' : 'Add'}</Button>
          </Flex>
        </ModalHeader><ModalCloseButton />
        <ModalBody>
          {showForm && (
            <Box bg="blue.50" p={3} borderRadius="md" mb={3}>
              <HStack spacing={2}>
                <FormControl flex={1}><FormLabel fontSize="xs" mb={0.5}>Name *</FormLabel>
                  <Input size="xs" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} /></FormControl>
                <FormControl flex={2}><FormLabel fontSize="xs" mb={0.5}>Base URL</FormLabel>
                  <Input size="xs" value={form.base_url} onChange={e => setForm(p => ({ ...p, base_url: e.target.value }))}
                    placeholder="https://example.com/" /></FormControl>
                <Button size="xs" bg="brand.600" color="white" _hover={{ bg: 'brand.700' }}
                  onClick={handleAdd} mt={4}>Add</Button>
              </HStack>
            </Box>
          )}
          <VStack spacing={1} align="stretch">
            {networks.map(n => (
              <Flex key={n.id} p={2} border="1px" borderColor="gray.100" borderRadius="md"
                align="center" justify="space-between">
                <Box><Text fontSize="12px" fontWeight="600">{n.name}</Text>
                  {n.base_url && <Text fontSize="9px" color="gray.400">{n.base_url}</Text>}</Box>
                <IconButton icon={<FiTrash2 />} size="xs" variant="ghost" colorScheme="red"
                  onClick={async () => { await api.delete(`/social/networks/${n.id}`); fetch(); }} aria-label="Delete" />
              </Flex>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter><Button size="sm" onClick={onClose}>Close</Button></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
